import { render, staticRenderFns } from "./PagamentoAdministrativoRead.vue?vue&type=template&id=219d6190&"
import script from "./PagamentoAdministrativoRead.vue?vue&type=script&lang=js&"
export * from "./PagamentoAdministrativoRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports